import RecorderEventMap from "./interface/RecorderEventMap";
import VideoRecorderConfig from "./interface/videoRecorderConfig";
//@ts-ignore
import { RecordRTCPromisesHandler, MediaStreamRecorder } from 'recordrtc'
import { enableControlls, disableControlls } from './utils/playerUtil'
import { CustomEventOnError, CustomEventOnInit, CustomEventOnMediaDeviceError, CustomEventOnPlayBack, CustomEventOnSave, CustomEventOnStopRecording, CustomEventOnUploadFileError, CustomEventOnUploadFileSuccess, CustomEventOnUploadProgress, CustomEventStartRecording } from "./types/customtypes";
import VideoRecorderService from "./service/videorecorder_service";
//@ts-ignore
import DetectRTC from 'detectrtc';
import { createNanoEvents, Emitter } from "nanoevents";
import { DataPyaload } from "./interface/payload";
import Resumable from 'resumablejs';
import ResumableService from "./service/resumableService";
import { AxiosResponse } from "axios";
import fixWebmDuration from "fix-webm-duration";



export class VideoRecorderBase {

    /** @type {RecordRTCPromisesHandler} */
    protected recorder: RecordRTCPromisesHandler | undefined | null;

    /** @type {MediaStream} */
    protected internal_stream: MediaStream | null = null!;

    /** @type {VideoRecorderConfig|any} */
    protected internal_config: VideoRecorderConfig | null | any = {};

    /** @type {HTMLVideoElement} */
    protected _video!: HTMLVideoElement | null;

    /** @type {Emitter<RecorderEventMap>} */
    private emitter: Emitter<RecorderEventMap>;

    /** @type {VideoRecorderService} */
    private videoRecorderService: VideoRecorderService | undefined;

    /** @type {Blob} */
    private internalBlob!: Blob | null;

    private hasmicrophone!: boolean;
    private startTime !:number;
    private haswebcam!: boolean;
    private fileExstention!: string;
    private resumable: Resumable | undefined;;
    private resumableSupport: boolean;
    private resumableService: ResumableService | undefined;
    private stream: MediaStream | undefined;
    /**
     * @type {VideoRecorderConfig}
     * */
    protected baseConfig: VideoRecorderConfig = {
        video_container_id: '#video-container',
        video_id: 'video',
        optional_data: null,
        mimeType: 'video/webm;codecs=H264',
        audio_only: false,
        resolution: {
            width: 1280,
            height: 720
        },
        container_width: "640px",
        container_height: "480px",
        projectName: '',
        DEBUG_MODE: true,
        backEndConfig: {
            endpoint: "https://localhost:44375/api/v1/VideoRecording",
            headers: {
                'X-Abintegro-ReferringId': "",
                'X-Abintegro-UserId': "",
                "X-Abintegro-ProjectName":"Interview360",
                "X-Abintegro-InterviewMaxLength":1,
                "X-Abintegro-AustralianHeiOnUkServer":false,
            },
            resumableEndPoint: '/Upload'
        },
        autosave: true,
        useResumable: true,
        interviewMaxLength: 1,
        australianHeiOnUkServer:false
    }
    /**
    *
    * @constructor
    * @param {VideoRecorderConfig?}
   */
    //@ts-ignore
    constructor(config?: VideoRecorderConfig | undefined | null) {
        if (typeof config == 'undefined' || config == null) {
            this.internal_config = this.baseConfig;
        } else {
            this.internal_config.audio_only = config.audio_only || this.baseConfig.audio_only;
            this.internal_config.video_container_id = config.video_container_id || this.baseConfig.video_container_id;
            this.internal_config.video_id = config.video_id || this.baseConfig.video_id;
            this.internal_config.optional_data = config.optional_data || this.baseConfig.optional_data;
            this.internal_config.projectName = config.projectName || this.baseConfig.projectName;
            this.internal_config.DEBUG_MODE = config.DEBUG_MODE || this.baseConfig.DEBUG_MODE;
            this.internal_config.mimeType = config.mimeType || this.baseConfig.mimeType;
            this.internal_config.resolution = config.resolution || this.baseConfig.resolution;
            this.internal_config.container_width = config.container_width || this.baseConfig.container_width;
            this.internal_config.container_height = config.container_height || this.baseConfig.container_height;
            this.internal_config.backEndConfig = config.backEndConfig || this.baseConfig.backEndConfig;
            this.internal_config.autosave = config.autosave;
            this.internal_config.backEndConfig.resumableEndPoint = config.backEndConfig.resumableEndPoint || this.baseConfig.backEndConfig.resumableEndPoint;
            this.internal_config.interviewMaxLength = config.interviewMaxLength || this.baseConfig.interviewMaxLength;
            this.internal_config.australianHeiOnUkServer = config.australianHeiOnUkServer || this.baseConfig.australianHeiOnUkServer;
            if (typeof config?.useResumable !== 'undefined') {
                this.internal_config.useResumable = config.useResumable;
            } else {
                this.internal_config.useResumable = this.baseConfig.useResumable
            }

        }
        this.emitter = createNanoEvents<RecorderEventMap>();
        this.resumable = new Resumable({
            target: `${this.internal_config.backEndConfig.endpoint}${this.internal_config.backEndConfig.resumableEndPoint}`,
            testMethod: "GET",
            testChunks: true,
            headers: {
                ...this.internal_config.backEndConfig.headers
            },
            maxFiles: 1,
            prioritizeFirstAndLastChunk: false,
            simultaneousUploads: 4,
            chunkSize: 2 * 1024 * 1024,
            query: {},
            //@ts-ignore
            permanentErrors: []
        });
        this.resumableSupport = this.resumable.support && this.internal_config.useResumable;
        if (!this.resumableSupport) {
            this.videoRecorderService = new VideoRecorderService(this.internal_config.backEndConfig);
            this.resumable = undefined;
            this.resumableService = undefined;
        } else {
            this.resumableService = new ResumableService(this.resumable, this.emitter, this.internal_config.backEndConfig.headers);

        }
        this._video = <HTMLVideoElement>document.querySelector(this.internal_config.video_id);

        if (this._video == null) {
            throw new Error('Could not find video element ');
        }


    }



    private checkCameraMicrophoneExist = () => {
        const initPromise = new Promise((resolve, reject) => {
            DetectRTC.load(() => {
                resolve(DetectRTC.hasWebcam && DetectRTC.hasMicrophone);
            });
        });

        return initPromise;
    }

    /**
     * Init function to call getuserDevide and initialise RecordRTCPromisesHandler
     * @return {Promise<void>} This is the result
     */
    public __init__ = async (): Promise<CustomEventOnInit | unknown> => {
        return new Promise(async (resolve, reject) => {
            const hasMediaDevice = await this.checkCameraMicrophoneExist()
            if (hasMediaDevice) {
                try {

                    if (this.recorder != null) {
                        this._video!.srcObject = null;
                        if (this._video!.src) {
                            (URL || webkitURL).revokeObjectURL(this._video!.src)
                        }
                        await this.recorder.reset();
                        await this.recorder.destroy();
                        this.recorder = null;
                        this.internal_stream = null;
                        this.internalBlob = null;
                    }

                    this.clearEvents();
                    this.stream = await navigator.mediaDevices.getUserMedia({
                        video: !this.internal_config.audio_only
                            ?
                            {
                                width: this.internal_config.resolution.width,
                                height: this.internal_config.resolution.height
                            }
                            : false,
                        audio: true,

                    });


                    if (this._video!.src) {
                        (URL || webkitURL).revokeObjectURL(this._video!.src)
                    }

                    this._video!.srcObject = this.stream;

                    this.internal_stream = this.stream;
                    this.recorder = new RecordRTCPromisesHandler(this.stream, {
                        type: !this.internal_config.audio_only ? 'video' : 'audio',
                        mimeType: this.getCodecFromBrowser(this.internal_config.audio_only),
                        recorderType: MediaStreamRecorder,
                        disableLogs: !this.internal_config.DEBUG_MODE,
                        timeSlice: 1000,
                        numberOfAudioChannels: 2,
                    });
                    this.disableControlls();
                    const onInitEvent: CustomEventOnInit = {
                        videoContainer: this._video!,
                        recorder: this.recorder.recordRTC,
                        stream: this.internal_stream
                    }
                    this.emitter.emit('AB_Custom_Event_On_Init', onInitEvent);
                    resolve(onInitEvent);

                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                let err!: Error;
                if (!this.haswebcam && !this.hasmicrophone) {
                    err = new Error(`WebCam is NOT present and microphone is not present`);
                } else if (!this.haswebcam && this.hasmicrophone) {
                    err = new Error(`WebCam is NOT present`);
                }
                else if (this.haswebcam && !this.hasmicrophone) {
                    err = new Error(`Microphone is NOT present`);
                }

                reject(err!);



            }
        });
    }

    protected __off__<E extends keyof RecorderEventMap>(event: E) {
        return this.emitter.on(event, () => { });
    }

    protected __IsResumableSupported__ = (): boolean => {
        return this.resumableSupport;
    }

    protected __generateUniqueFileName__ = (): string => {
        //@ts-ignore
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }




    private __reinitVideoPlayer__ = (blob: Blob) => {
        if (typeof blob != 'undefined' && blob != null && blob.size > 0) {
            const oldvideocontaineClass = this._video!.className;
            this._video!.remove();
            const container = document.querySelector(this.internal_config.video_container_id);
            const fragment = document.createDocumentFragment();
            this._video = document.createElement('video');
            this._video.id = this.internal_config.video_id.slice(1);
            this._video.className = oldvideocontaineClass;
            this._video.controls = true;
            this._video.muted = false;
            this._video.autoplay = false;
            //@ts-ignore
            this._video.playsInline = true;
            this._video.src = (URL || webkitURL).createObjectURL(blob);
            this._video.onplaying = (e) => {
                const onPlayBackEvent: CustomEventOnPlayBack = {
                    player: this._video!

                }
                this.emitter.emit('AB_Custom_Event_On_PlayBack', onPlayBackEvent);
            }
            fragment.appendChild(this._video);
            container.appendChild(fragment);
            this._video.load();
        }

    }

    private stopRecordingCallback = async (): Promise<void> => {
        try {

            this._video!.srcObject = null;
            const duration =  Date.now() - this.startTime;
            let blob = await this.recorder!.getBlob();
            blob = await fixWebmDuration(blob, duration, {logger: false});
            this.recorder!.stream?.stop();
            this.recorder!.stream?.getTracks((t: any) => t.stop());
            this.internalBlob = new Blob([blob], { type: 'video/webm' })
            this.__reinitVideoPlayer__(blob!);
            let response: AxiosResponse<any> | undefined;
            if (this.internal_config.autosave) {
                if (typeof blob != 'undefined' && blob != null && blob.size > 0) {
                    response = await this.__postVideoFile__(blob, this.__generateUniqueFileName__());
                }
                if (!this.resumableSupport) {
                    const onVideoSavedEvent: CustomEventOnSave = {
                        status: response ? response?.status : undefined,
                        data: response ? response?.data : {},
                        message: response ? response?.statusText : "",
                    }
                    this.emitter.emit('AB_Custom_Event_On_Save', onVideoSavedEvent);
                }
            }
            await this.recorder!.reset();
            await this.recorder!.destroy();
            const tracks = this.stream?.getTracks();
            tracks?.forEach(function (track) {
                if (track.readyState == 'live') {
                track.stop();
                 }
            });
            this.recorder = null;


        }
        catch (error) {
            if (this.internal_config.DEBUG_MODE) {
                console.debug(error)
            }

            const onErrorEvent: CustomEventOnError = {
                error: error,
                trace: "Error  happened on stopRecordingCallback call",
                message: '',

            }
            this.emitter.emit('AB_Custom_Event_On_Error', onErrorEvent);

        }

    }

    private __postVideoFile__ = async (videoByteArray: Blob, fileName: string): Promise<AxiosResponse<any> | undefined> => {


        const payload: DataPyaload = {
            Stream: videoByteArray!,
            FileName: fileName + this.fileExstention,
            ContentType: this.getcontentType(this.internal_config.audio_only),
            ProjectName: this.internal_config.projectName,
            InterviewMaxLength: this.internal_config.interviewMaxLength,
            AustralianHeiOnUkServer : this.internal_config.australianHeiOnUkServer
        }
        try {
            if (this.resumableSupport) {
                return this.resumableService!.UploadVideo(payload);

            } else {
                const response = await this.videoRecorderService!.PostVideo(payload);
                return response;
            }
        } catch (err) {
            const onErrorEvent: CustomEventOnError = {
                error: err,
                trace: "Error  happened on PostVideo call",
                message: '',

            }
            this.emitter.emit('AB_Custom_Event_On_Error', onErrorEvent);
        }

    }
    protected __Retry__ = () => {
        if (this.resumable!.files[0].file && this.resumable!.files[0].file.size > 0) {
            this.resumable!.files[0].retry();
        }
    }
    protected __manualSave__ = async (fileName: string) => {

        if (typeof this.internalBlob != 'undefined' && this.internalBlob != null && this.internalBlob.size > 0) {
            try {

                const response = await this.__postVideoFile__(this.internalBlob, fileName);
                if (!this.resumableSupport) {
                    if (response?.status == 200) {
                        return {
                            status: response.status,
                            data: JSON.parse(response?.data),
                            message: response ? response?.statusText : "",
                        }
                    } else {
                        return {
                            status: response?.status,
                            data: {},
                            message: response?.statusText
                        }
                    }
                }
            }

            catch (error) {
                if (this.internal_config.DEBUG_MODE) {
                    console.error(error)
                }
                throw error;
            }
        } else {
            const error = new Error("No video is found ");
            throw error;

        }


    }
    protected __stopRecording__ = async (): Promise<void> => {
        if (this.recorder != null) {
            await this.recorder.stopRecording();
            await this.stopRecordingCallback();
        } else {
            return;
        }
    }
    protected __deInit__ = async (): Promise<any | unknown> => {
        return new Promise(async (resolve, reject) => {
            if (this.recorder && this.recorder != null) {
                this._video!.srcObject = null;
                this.recorder.stream?.stop();
                this.recorder.stream?.getTracks((t: any) => t.stop());
                await this.recorder?.reset();
                await this.recorder?.destroy();
                const tracks = this.stream?.getTracks();
                tracks?.forEach(function (track) {
                    if (track.readyState == 'live') {
                        track.stop();
                    }
                });
                this.recorder = null;
                resolve({});

            } else {
                try {
                    this._video!.srcObject = null;
                    const tracks = this.stream?.getTracks();
                    tracks?.forEach(function (track) {
                        if (track.readyState == 'live') {
                            track.stop();
                             }
                    });
                    resolve({});
                } catch (e) {
                    reject(e);
                }
            }
        });
    }

    protected __on__<E extends keyof RecorderEventMap>(event: E, callback: RecorderEventMap[E]) {
        return this.emitter.on(event, callback)
    }

    private disableControlls = (): void => {
        disableControlls(this._video!);
    }

    private enableControlls = (): void => {
        enableControlls(this._video!);
    }

    protected __startRecording__ = async (): Promise<void> => {
        try {

            this.recorder!.startRecording();
            this.recorder!.stream = this.internal_stream;
            const internalRecorder = await this.recorder!.getInternalRecorder();
            const internalRecorderstate = await this.recorder!.getState()
            const onStartRecording: CustomEventStartRecording = {
                recorderState: internalRecorderstate,
                internalRecorder: internalRecorder,
                internalRecorderName: internalRecorder.name,
                stream: this.internal_stream!
            }
            this.emitter.emit('AB_Custom_Event_On_Start_Recording', onStartRecording);
            this.startTime =  Date.now();
        }
        catch (error) {
            if (this.internal_config.DEBUG_MODE) {
                console.debug(error)
            }

            const onErrorEvent: CustomEventOnError = {
                error: error,
                trace: "Error  happened on __startRecording__ call",
                message: '',
            }
            this.emitter.emit('AB_Custom_Event_On_Error', onErrorEvent);

        }
    }

    private clearEvents(): void {
        this.emitter.on('AB_Custom_Event_On_Get_Media_Device', () => { });
        this.emitter.on('AB_Custom_Event_On_Init', () => { });
        this.emitter.on('AB_Custom_Event_On_Start_Recording', () => { });
        this.emitter.on('AB_Custom_Event_On_Stop_Recording', () => { });
        this.emitter.on('AB_Custom_Event_On_Error', () => { });
        this.emitter.on('AB_Custom_Event_On_Save', () => { });
        this.emitter.on('AB_Custom_Event_On_PlayBack', () => { });
        this.emitter.on('AB_Custom_Event_Remove_Event', () => { });
    }

    private getCodecFromBrowser(isaudioOnly: boolean = false) {
        if (isaudioOnly) {
            if (DetectRTC.browser.isFirefox) {
                this.internal_config.mimeType = 'audio/ogg';
                return 'audio/ogg';
            } else {

                this.internal_config.mimeType = 'audio/webm;codecs=pcm';
                return 'audio/webm;codecs=pcm';
            }

        }

        if (DetectRTC.browser.isChrome || DetectRTC.browser.isEdge || DetectRTC.browser.isOpera || DetectRTC.browser.isSafari) {
            this.internal_config.mimeType = 'video/webm;codecs=h264';
            this.fileExstention = ".mkv"
            return 'video/webm;codecs=h264';

        }
        else if (DetectRTC.browser.isFirefox) {
            this.internal_config.mimeType = 'video/webm';
            this.fileExstention = ".webm"
            return 'video/webm';
        }
    }
    private getcontentType(isaudioOnly: boolean = false): string {

        if (isaudioOnly) {
            if (DetectRTC.browser.isFirefox) {

                return 'audio/ogg';
            } else {


                return 'audio/webm';
            }

        } else {

            if (DetectRTC.browser.isChrome || DetectRTC.browser.isEdge || DetectRTC.browser.isOpera || DetectRTC.browser.isSafari) {

                return 'video/x-matroska';

            }
            else if (DetectRTC.browser.isFirefox) {

                return 'video/webm';
            }
            else {

                return 'video/webm';
            }
        }
    }




}
